import { routeTree } from '@analyzer/routeTree.gen'
import { queryClient } from '@api/query-client'
import { RouteErrorScreen } from '@design/components/screens/route-error-screen/RouteErrorScreen'
import { createRouter } from '@tanstack/react-router'

// Create a new router instance
export const router = createRouter({
  basepath: import.meta.env.VITE_BASE_URL || '/',
  routeTree,
  context: { queryClient },
  defaultErrorComponent: RouteErrorScreen,
  defaultViewTransition: true,
  scrollRestoration: true,
  getScrollRestorationKey: (location) => location.pathname,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
